import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DatetimePickerModalComponent } from './datetime-picker.component';
import { DatetimePickerModalService } from './datetime-picker.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DatetimePickerModule } from '@schoolbelle/shared/components';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    FormsModule,
    DatetimePickerModule,

  ],
  declarations: [
    DatetimePickerModalComponent
  ],
  providers:[
    DatetimePickerModalService,
  ],
  entryComponents: [
    DatetimePickerModalComponent
  ],
})
export class DatetimePickerModalModule { }
